import React from 'react'
import CanadaTemplateDefault from 'src/components/template/ca/'
import { leagueIds, sportIds } from 'src/constants'

export default (props) => {
  return (
    <CanadaTemplateDefault
      location={props.location}
      lang="en"
      market="canada"
      video={'https://assets.fubo.tv/marketing/lp/videos/compressed/MLB_Spring_2022_13s.mp4'}
      title="Watch MLB Network with Fubo"
      subtitle="Live games, MLB Tonight and more"
      networkSet="canada_sports"
      customNetworks={['mlbnetwork']}
      sportId={sportIds.Baseball}
      leagueId={leagueIds.MLB}
    />
  )
}
